export default{
	install(Vue,options)
	{
		Vue.prototype.curLang = (function(){
            if(location.hostname.indexOf('7msport') > -1)
				return 'en';
			else if(location.hostname.indexOf('7mkr') > -1)
				return 'kr';
			else if(location.hostname.indexOf('7mth') > -1)
				return 'th';
			else if(location.hostname.indexOf('7mvn') > -1)
				return 'vn';
			else if(location.hostname.indexOf('-id.7msport') > -1)
				return 'en';
			else
				return 'gb';
			
		})();

		Vue.prototype.txtLang = {
			'gb':{
                '7mSport':'7M 竞猜',
                'guessOrder':'竞猜订单',
                'guessOrderDetail':'订单详情',
                'guessRule':'竞猜规则',
                'mCoin':'M 币',
                'market':'商城',
                'reward':'抽奖',
                'task':'任务',
                'taskRule':'任务说明',
                'today':'今日',
                'future':'未来',
                'betUpLimit':'投注数已达上限',
                'bet':'投注',
                'hot':'热门',
                'new':'最新',
                'locked':'封盘',
                'screenError':'需要选择至少一个联赛',
                'hasBet':'当前玩法已参与竞猜',
                'oneBet':'每种玩法仅可选择一项投注内容',
                'noMatch':'暂无可竞猜赛事',
                'sealAccout':'由于您的账号存在违规操作，本次操作无效',
                'playType':['','胜平负','让球','大小球'],
                'winCoinBack':function(num){
                    return '净胜返还<span>' + num + '</span>M币'
                },
                'betName':'Bet Slip',
                'overBetMax':'最多只能同时投注{value}场，请完成投注后重新添加',
                'playOption':[
                    [],
                    ['主胜','客胜','平'],
                    ['主胜','客胜'],
                    ['大球','小球']
                ],
                'errorTip':[
                    '',
                    '单次投注最小为{value}M币。',
                    '单次投注最大为{value}M币。',
                    '单次返奖最高为{value}M币。',
                    '竞猜已截止。',
                    '已封盘。',
                    '您剩余M币数不足以投注，当前剩余{value}M币。',
                    '指数发生变化。',
                    '今天您最多还能投注{value}M币。',
                    '哇，您今天投注已达到最大{value}M币了，先休息下吧。',
                    '本场比赛您最多还能投注{value}M币。',
                    '已达投注上限，请选择其它竞猜。',
                    '返奖额已达本投注上限，请选择其他竞猜。',
                    '返奖额已达本玩法上限，请选择其他竞猜。',
                    '返奖额已达本场比赛上限，请选择其他竞猜。',
                    '指数发生变化。',
                    '当前玩法已参与，请选择其他竞猜。'
                ],
                'winCoin':function(num){
                    var str = '净胜 {value} M币';
                    return str.replace(/{value}/g,'<b>' + num + '</b>');
                },
                'loginAndGet':'登录领取',
                'youGot':'恭喜您获得',
                'guideP1':'可用于竞猜投注及抽奖，快来参与',
                'guideP2':'积累M券可到商城兑换商品',
                'guideP3':'仅限首次登录用户',
                'guideP4':'多种玩法赢M币',
                'guideP5':'幸运转盘换大礼',
                'signError':'今日签到任务已完成，明天再来吧',
                'signSuccess':'签到成功！',
                'firstDay':'第一天',
                'secondDay':'第二天',
                'thirdDay':'第三天',
                'waitGet':'待领取',
                'done':'已完成',
                'todayTask':'今日任务',
                'toBet':'去投注',
                'toFinish':'去完成',
                'toReward':'去抽奖',
                'signIn':'签到',
                'taskFinishTip':'太棒了，今日任务已完成',
                'moreGuessHistory':'更多竞猜历史',
                'orderSn':'订单号',
                'betPlayType':'玩法',
                'handicap':'盘口',
                'betTypeAndOdds':'投注玩法&赔率',
                'betNum':'投注数额',
                'betTime':'投注时间',
                'remark':'备注',
                'cancelOrigin':'取消原因',
                'returnAll':'M币全数返还',
                'all':'全部',
                'hasReward':'已开奖',
                'rewarding':'待开奖',
                'hasCancel':'已取消',
                'betFail':'投注失败',
                'betFailTxt':'提交竞猜出了点问题，请重新操作',
                'betSuccess':'投注成功',
                'betting':'拼命提交中',
                'guessHistory':'竞猜订单',
                'goOnGuess':'继续竞猜',
                'leagueScreen':'赛事筛选',
                'allSelect':'全选',
                'contractSelect':'反选',
                'confirm':'确定',
                'know':'知道了',
                'close':'关闭',
                'cancel':'取消',
                'totalBet':'总投注',
                'totalBack':'预计返还',
                'select':'已投',
                'login': '登录',
                'userCenter': '个人中心',
                'mGuess': '竞猜',
                'mTask': '任务',
                'mMall': '商城',
                'mGuessList': '竞猜订单',
                'mRule': '竞猜规则',
                'mMessage': '通知',
                'noticeTitle': '我的通知',
                'exchangeTitle': '兑换记录',
                'exchangeTab': ['全部', '待审核', '兑换成功', '兑换失败'],
                'eShopCode': '购物券码：',
                'eCopy': '复制',
                'eOrder': '订单号：',
                'eCoupon': '消耗M券：',
                'eM': ' M券',
                'eStartTime': '发起时间：',
                'eEndTime': '完成时间：',
                'noData': '暂无数据',
                'eCopySuccess': '复制成功',
                'myCoins': '我的M币',
                'myCoupon': '我的M券',
                'unit': '张',
                'giftChange': '兑换好礼',
                'changeRecord': '兑换记录',
                'changeBtn': '可兑换',
                'needMore': '还差#p张',
                'changeLeft': '剩余#p张',
                'changeTips': '集齐#p张M券兑换',
				'confirmTitle': '操作提示',
				'confirmCancel': '取消',
				'confirmText': '确认',
				'confirmNow': '知道了',
				'confirmExchange': '本次兑换将消耗#pM券',
				'confirmSuccessTips': '工作人员将尽快为您处理!',
				'confirmErrorTitle': '兑换失败',
				'confirmErrorTips': '提交过程出了点问题，请重新操作。',
				'luckyDraw': '抽奖',
				'lotteryTab': ['免费抽', 'M币抽'],
				'lotteryNavTab': ['抽奖规则', '中奖记录'],
				'lotteryPrize': '奖品',
				'lotteryTime': '获奖时间',
				'lotteryCodeTips': '请稍等，购物券很快送达~',
				'lotteryMore': '加载更多',
				'lotteryNoLogin': '登录抽大奖',
				'lotteryFreeChangeTips': '还有<strong>#p</strong>次免费抽奖机会',
                'lotteryFreeEnd': '今日免费抽奖机会已用完',
                'lotteryChangeTips': '还有<strong>#p</strong>次抽奖机会',
                'lotteryFree': '免费',
                'lotteryClose': '关闭',
                'lotteryMCoinNo': '您的M币不足，无法参与抽奖。',
                'lotteryWinTitle': '恭喜您获得',
                'lotteryWinTips': '工作人员将尽快为您处理，请注意查看中奖记录。',
                'lotteryWinName': ['', '#p M券', '#p M币', '亚马逊购物券'],
                'lotterySorryTips': '遗憾，您与奖品擦肩而过。再试一次吧！',
                'lotteryConfirm': '确认',
                'lotteryCheck': '前往查看',
				'loginFirst': '请先登录'
            },
			'en': {
				'7mSport':'7M Guess',
                'guessOrder':'Guess Orders',
                'guessOrderDetail':'Order Details',
                'guessRule':'Guess Rules',
                'mCoin':'M Coins',
                'market':'Shop',
                'reward':'Lucky Draw',
                'task':'Task',
                'taskRule':'Task Introduction',
                'today':'Today',
                'future':'Future',
                'betUpLimit':'Limit Reached',
                'bet':'Place',
                'hot':'Hot',
                'new':'Latest',
                'locked':'Closed',
                'screenError':'Please select at least 1 league.',
                'hasBet':'You are already involved in the current type.',
                'oneBet':'Only one option can be placed for each type.',
                'noMatch':'No games for guessing yet.',
                'sealAccout':'Due to violations of your account, this operation is invalid.',
                'playType':['','1X2','AH','Over/Under'],
                'winCoinBack':function(num){
                    return 'Win and Return <span>' + num + '</span> M Coins'
                },
                'betName':'Placed List',
                'overBetMax':'You can only place {value} games at the same time. Please add again after that.',
                'playOption':[
                    [],
                    ['Home Win','Away Win','Draw'],
                    ['Home Win','Away Win'],
                    ['Over','Under']
                ],
                'errorTip':[
                    '',
                    '{value} M Coins at least per order',
                    '{value} M Coins at most per order',
                    '{value} M Coins at most per prize return',
                    'Sorry, the game is closed for Guessing and cannot be placed.',
                    'The game has been closed and cannot be placed.',
                    'Your remaining M Coins are insufficient to place. There are {value} M Coins left.',
                    'The odds have been changed. ',
                    'You can still place with at most {value} M Coins today.',
                    'Wow, you have reached the maximum of {value} M Coins today. Take a break please.',
                    'You can still place with at most {value} M Coins for this game.',
                    'You have reached the upper limit and cannot continue to place.',
                    'You have reached the upper limit of this option and cannot continue to place.',
                    'You have reached the upper limit of this option and cannot continue to place.',
                    'You have reached the upper limit of this option and cannot continue to place.',
                    'The odds have been changed. ',
                    'You are already involved in the current type.'
                ],
                'winCoin':function(num){
                    var str = 'Won {value} M Coins';
                    return str.replace(/{value}/g,'<b>' + num + '</b>');
                },
                'loginAndGet':'Login now and get',
                'youGot':"",
                'guideP1':'Available on Guess and Lucky Draw. Join now!',
                'guideP2':'The accumulated M Coupons can be exchanged at the shop.',
                'guideP3':'For new login user only',
                'guideP4':'Multiple ways to earn M Coins',
                'guideP5':'Spin the lucky wheel to win prize',
                'signError':'The sign-in task has been completed today. Please come back tomorrow!',
                'signSuccess':'Sign In successfully!',
                'firstDay':'1st Day',
                'secondDay':'2nd Day',
                'thirdDay':'3rd Day',
                'waitGet':'Unclaimed',
                'done':'Finished',
                'todayTask':"Today's Task",
                'toBet':'Place',
                'toFinish':'Earn Now',
                'toReward':'Spin Now',
                'signIn':'Sign In',
                'taskFinishTip':'Great! You have finished the task today.',
                'moreGuessHistory':'More Guessing Records',
                'orderSn':'Order NO.',
                'betPlayType':'Type',
                'handicap':'AH Line',
                'betTypeAndOdds':'Place Type & Odds',
                'betNum':'Place Amount',
                'betTime':'Place Time',
                'remark':'Notes',
                'cancelOrigin':'Cancelled Reason',
                'returnAll':'All M Coins returned',
                'all':'All',
                'hasReward':'Results',
                'rewarding':'Upcoming',
                'hasCancel':'Cancelled',
                'betFail':'Place failed',
                'betFailTxt':'There was a problem of submitting. Please try again.',
                'betSuccess':'Placed successfully!',
                'betting':'Submitting',
                'guessHistory':'Guess Orders',
                'goOnGuess':'Next One',
                'leagueScreen':'Select Competition',
                'allSelect':'Select All',
                'contractSelect':'Invert Selection',
                'confirm':'Yes',
                'know':'Got it',
                'close':'Close',
                'cancel':'No',
                'totalBet':'Total Placed',
                'totalBack':'Expected Return',
                'select':'Placed',
                'login': 'Log In',
                'userCenter': 'Personal Center',
                'mGuess': 'Guess',
                'mTask': 'Task',
                'mMall': 'Shop',
                'mGuessList': 'Guess Orders',
                'mRule': 'Guess Rules',
                'mMessage': 'Notification',
                'noticeTitle': 'My Notification',
                'exchangeTitle': 'Exchange Record',
                'exchangeTab': ['All', 'Check Pending', 'Successful', 'Failed'],
                'eShopCode': 'Voucher Code：',
                'eCopy': 'Copy',
                'eOrder': 'Order NO.：',
                'eCoupon': 'M Coupon Consumption：',
                'eM': ' M Coupons',
                'eStartTime': 'Application Time：',
                'eEndTime': 'Finish Time：',
                'noData': 'No content yet',
                'eCopySuccess': 'Successfully copied',
                'myCoins': 'M Coins',
                'myCoupon': 'M Coupons',
                'unit': '',
                'giftChange': 'Gift Exchange',
                'changeRecord': 'Exchange Record',
                'changeBtn': 'Exchangeable',
                'needMore': 'need #p more',
                'changeLeft': '#p left',
                'changeTips': 'Collect #p M Coupons to exchange',
                'confirmTitle': 'Operation Instruction',
                'confirmCancel': 'No',
                'confirmText': 'Yes',
                'confirmNow': 'Got it',
                'confirmExchange': 'The exchange will consume #p M Coupons.',
                'confirmSuccessTitle': 'Successful',
                'confirmSuccessTips': 'The staff will handle it for you as soon as possible.',
                'confirmErrorTitle': 'Exchange Failed',
                'confirmErrorTips': 'Something went wrong during the submission process. Please try again.',
                'luckyDraw': 'Lucky Draw',
                'lotteryTab': ['Play for Free', 'Play with M Coins'],
                'lotteryNavTab': ['Lucky Draw Rules', 'Winning Records'],
                'lotteryPrize': 'Prize',
                'lotteryWinTime': 'Time',
                'lotteryCodeTips': 'The gift card will be delivered soon.',
                'lotteryMore': 'More',
                'lotteryTime': 'Time',
                'lotteryNoLogin': 'Log in for Lucky Draw',
                'lotteryFreeChangeTips': '<strong>#p</strong> free chances to play',
                'lotteryFreeEnd': "You've run out the free chance of Lucky Draw today.",
                'lotteryChangeTips': '<strong>#p</strong> chances left to play',
                'lotteryFree': 'Free',
                'lotteryClose': 'Close',
                'lotteryMCoinNo': 'Your M Coins are insufficient to play Lucky Draw.',
                'lotteryWinTitle': "Congratulations! You've received",
                'lotteryWinTips': 'The staff will handle it for you as soon as possible. Please pay attention to the winning records.',
                'lotteryWinName': ['', '#p M Coupons', '#p M Coins', '[Amazon] Gift Card'],
                'lotterySorryTips': 'You\'ve missed the prize. Try it again!',
				'lotteryConfirm': 'Confirm',
				'lotteryCheck': 'Check it out',
                'loginFirst': 'Please log in first.'
			},
			'kr':{
				'7mSport':'7M 퀴즈 게임',
                'guessOrder':'퀴즈 내역',
                'guessOrderDetail':'주문 내역',
                'guessRule':'퀴즈 규칙',
                'mCoin':'M코인',
                'market':'쇼핑몰',
                'reward':'추첨',
                'task':'미션',
                'taskRule':'미션 설명',
                'today':'오늘',
                'future':'미래',
                'betUpLimit':'참여한도에 도달',
                'bet':'참여하기',
                'hot':'인기',
                'new':'최신',
                'locked':'마감',
                'screenError':'적어도 한가지 리그를 선택하셔야 합니다.',
                'hasBet':'현 플레이법은 퀴즈 게임에 참여한 것입니다.',
                'oneBet':'플레이법당 한 가지 참여 내역만 선택 가능',
                'noMatch':'현재 퀴즈 게임을 할 수 있는 경기가 없습니다.',
                'sealAccout':'해당 계정은 규칙위반 행위로 이번 요청이 무효입니다.',
                'playType':['','승무패','핸디캡','오버/언더'],
                'winCoinBack':function(num){
                    return '반환 M코인 <span>' + num + '</span>개';
                },
                'betName':'참여 내역',
                'overBetMax':'최대 {value}경기만 동시에 참여할 수 있으니 참여 완료후 다시 추가하세요.',
                'playOption':[
                    [],
                    ['홈승','원정승','무'],
                    ['홈승','원정승'],
                    ['오버','언더']
                ],
                'errorTip':[
                    '',
                    '단번 최소 참여한도는 M코인 {value}개입니다.',
                    '단번 최대 참여한도는 M코인 {value}개입니다.',
                    '단번 최대 당첨한도는 M코인 {value}개입니다.',
                    '퀴즈 게임은 마감되었습니다.',
                    '마감되었음',
                    '현 보유 M코인 수량이 {value}개로 게임 참여에 부족합니다.',
                    '배당률이 변경되었으니 확인하시고 다시 참여하세요.',
                    '오늘 최대 M코인 {value}개를 더 참여할 수 있습니다.',
                    '어머,오늘 최대 참여한도 M코인 {value}개에 달했습니다.잠깐 쉬세요.',
                    '본 경기는 최대 M코인 {value}개만 더 참여하실 수 있습니다.',
                    '참여한도에 달했으니 다른 퀴즈를 선택하세요.',
                    '당첨액은 본 항목의 한도에 달했으니 다른 퀴즈를 선택하세요.',
                    '당첨액은 본 플레이법의 한도에 달했으니 다른 퀴즈를 선택하세요.',
                    '당첨액은 본 경기의 한도에 달했으니 다른 퀴즈를 선택하세요.',
                    '배당률이 변경되었으니 확인하시고 다시 참여하세요.',
                    '현 플레이법은 퀴즈 게임에 참여한 것입니다.'
                ],
                'winCoin':function(num){
                    var str = 'M코인 {value}개를 획득';
                    return str.replace(/{value}/g,'<b>' + num + '</b>');
                },
                'loginAndGet':'로그인 수령',
                'youGot':'축하합니다.',
                'guideP1':'퀴즈 게임및 추점에 사용 가능, 빨리 참여하기',
                'guideP2':'M권을 누적하면 쇼핑몰에서 상품으로 교환 가능',
                'guideP3':'첫 로그인만 적용',
                'guideP4':'다양한 방법으로 M코인을 획득하세요.',
                'guideP5':'행운의 돌림판을 돌려 상품을 받아 가세요.',
                'signError':'오늘 출석체크에 성공하셨습니다.내일 또 오세요!',
                'signSuccess':'출석체크에 성공하셨습니다.',
                'firstDay':'1번째 날',
                'secondDay':'2번째 날',
                'thirdDay':'3번째 날',
                'waitGet':'미수령',
                'done':'완료됨',
                'todayTask':'오늘 미션',
                'toBet':'참여하기',
                'toFinish':'받으러 가기',
                'toReward':'추첨으로 가기',
                'signIn':'출석체크',
                'taskFinishTip':'짱！오늘 미션이 완료되었습니다.',
                'moreGuessHistory':'참여 내역 더 보기',
                'orderSn':'주문 번호',
                'betPlayType':'플레이법',
                'handicap':'핸디캡',
                'betTypeAndOdds':'플레이법&배당률',
                'betNum':'참여 액수',
                'betTime':'참여 시간',
                'remark':'비고',
                'cancelOrigin':'취소 원인',
                'returnAll':'M코인 전부 반환',
                'all':'전체',
                'hasReward':'발표됨',
                'rewarding':'발표전',
                'hasCancel':'취소됨',
                'betFail':'참여에 실패하셨습니다.',
                'betFailTxt':'제출하는 데 문제가 생겼으니 다시 요청해 보십시오.',
                'betSuccess':'참여에 성공하셨습니다!',
                'betting':'제출 중...',
                'guessHistory':'퀴즈 내역',
                'goOnGuess':'계속 참여하기',
                'leagueScreen':'경기 선별',
                'allSelect':'모두 선택',
                'contractSelect':'반전 선택',
                'confirm':'확인',
                'know':'알겠습니다.',
                'close':'닫기',
                'cancel':'취소',
                'totalBet':'참여 합계',
                'totalBack':'반환 예상',
                'select':'참여 완료',
                'login': '로그인',
                'userCenter': '내 정보',
                'mGuess': '퀴즈 게임',
                'mTask': '미션',
                'mMall': '쇼핑몰',
                'mGuessList': '퀴즈 내역',
                'mRule': '퀴즈 규칙',
                'mMessage': '알림',
                'noticeTitle': '내 알림',
                'exchangeTitle': '교환 내역',
                'exchangeTab': ['전체', '심사 대기', '교환 성공', '교환 실패'],
                'eShopCode': '상품권번호：',
                'eCopy': '복사',
                'eOrder': '주문 번호：',
                'eCoupon': 'M권소모：',
                'eM': ' M권',
                'eStartTime': '신청시간：',
                'eEndTime': '완성시간：',
                'noData': '해당 내용이 없습니다.',
                'eCopySuccess': '복사 성공',
                'myCoins': '내 M코인',
                'myCoupon': '내 M권',
                'unit': '장',
                'giftChange': '상품으로 교환',
                'changeRecord': '교환 내역',
                'changeBtn': '교환 가능',
                'needMore': '#p장 부족함',
                'changeLeft': '재고: #p',
                'changeTips': 'M권 #p장을 모아 교환하기',
                'confirmTitle': '사용안내',
                'confirmCancel': '취소',
                'confirmText': '확인',
                'confirmNow': '알겠습니다.',
                'confirmExchange': '이번은 M권 #p장을 소모할 것입니다.',
                'confirmSuccessTitle': '교환 성공!',
                'confirmSuccessTips': '관리자가 최대한 빨리 처리해 드리겠습니다.!',
                'confirmErrorTitle': '교환 실패',
                'confirmErrorTips': '제출 과정 중에 문제가 좀 생겼으니 다시 시도해 보세요.',
                'luckyDraw': '추첨',
                'lotteryTab': ['무료 추첨', 'M코인으로 추첨'],
                'lotteryNavTab': ['추첨 규칙', '당첨 기록'],
                'lotteryPrize': '상품',
                'lotteryTime': '당첨 시간',
                'lotteryMore': '더 보기',
                'lotteryNoLogin': '추첨하러 로그인',
                'lotteryFreeChangeTips': '<strong>#p</strong>번 추첨 기회 남았음',
                'lotteryFreeEnd': '오늘의 무료 추첨 기회가 다 소진되었습니다.',
                'lotteryChangeTips': '<strong>#p</strong>번 추첨 기회 남았음',
                'lotteryFree': '무료',
                'lotteryClose': '닫기',
                'lotteryMCoinNo': 'M코인이 부족해서 추첨에 참여하실 수 없습니다.',
                'lotteryWinTitle': '축하합니다.',
                'lotteryWinTips': '관리자가 최대한 빨리 처리해 드릴 것이니 당첨 내역을 잘 체크해 보세요.',
                'lotteryWinName': ['','M권 #p 장','M코인 #p 개','【아마존】상품권'],
                'lotterySorryTips': '유감스럽지만 이번에 당첨이 되지 않았습니다. 다시 한번 도전해 보세요.',
                'lotteryConfirm': '확인',
                'lotteryCheck': '보러 가기',
                'loginFirst': '먼저 로그인 하세요!'
			},
			'th': {
				'7mSport':'7M ทาย',
                'guessOrder':'บิลของเกมทาย',
                'guessOrderDetail':'รายละเอียดของบิล',
                'guessRule':'กฎกติกาของเกมทาย',
                'mCoin':'เหรียญM',
                'market':'ร้านค้า',
                'reward':'หมุนรางวัล',
                'task':'กิจกรรม',
                'taskRule':'คำชี้แจงของกิจกรรม',
                'today':'วันนี้',
                'future':'วันข้างหน้า',
                'betUpLimit':'ยอดการเล่นถึงขีดจำกัดบนแล้ว',
                'bet':'เล่น',
                'hot':'ฮอต',
                'new':'ล่าสุด',
                'locked':'ปิดราคา',
                'screenError':'อย่างน้อยเลือก 1 ลีก',
                'hasBet':'คุณได้ทายเกมในวิธีการเล่นของรูปแบบนี้แล้ว',
                'oneBet':'เลือกได้ข้อเดียวในการเล่นในแต่ละรูปแบบของวิธีการเล่นเท่านั้น',
                'noMatch':'ตอนนี้ไม่มีเกมที่ทายได้',
                'sealAccout':'การปฏิบัติครั้งนี้ไม่มีผลบังคับใช้เนื่องจากบัญชีของคุณปฏิบัติผิดกฎกติกา',
                'playType':['','1x2','แฮนดิแคป','สูง/ต่ำ'],
                'winCoinBack':function(num){
                    return 'คืนกำไร <span>' + num + '</span> เหรียญM'
                },
                'betName':'ตารางการเล่น',
                'overBetMax':'อย่างมากเล่นได้ {value} เกมในครั้งเดียว โปรดเล่นก่อนแล้วเพิ่มใหม่',
                'playOption':[
                    [],
                    ['ทีมเหย้าชนะ','ทีมเยือนชนะ','เสมอ'],
                    ['ทีมเหย้าชนะ','ทีมเยือนชนะ'],
                    ['สกอร์สูง','สกอร์ต่ำ']
                ],
                'errorTip':[
                    '',
                    'อย่างน้อยเล่น {value} เหรียณMต่อครั้ง',
                    'อย่างมากเล่น {value} เหรียณMต่อครั้ง',
                    'อย่างมากคืนกำไร {value} เหรียณMต่อครั้ง',
                    'ขอโทษ หมดเวลาทายผลของเกมนี้แล้ว ไม่สามารถเล่นต่อ',
                    'เกมนี้ปิดราคาแล้ว ไม่สามารถเล่นต่อ',
                    'เหรียญMของคุณไม่เพียงพอ ตอนนี้เหลือ {value}เหรียญM',
                    'ดัชนีเปลี่นไป โปรดยืนยันก่อนแล้วค่อยเล่นใหม่',
                    'คุณสามารถเล่นอีก {value} เหรียญMในวันนี้',
                    'โอ้โฮ ยอดการเล่นของคุณถึงขีดจำกัดบนเป็น {value} เหรียญMแล้ว กรุณาพักผ่อนก่อน',
                    'เกมนี้คุณสามารถเดิมอีก {value} เหรียญM',
                    'ถึงขีดจำกัดบนของยอดเล่นแล้ว ไม่สามารถเล่นต่อ คุณสามารถทายเกมอื่น',
                    'ยอดกำไรของเกมนี้ถึงขีดจำกัดบนของยอดการเล่นของข้อนี้แล้ว ไม่สามารถเล่นต่อ กรุณาเลือกข้ออื่นหรือวิธีการเล่นอื่น',
                    'ยอดกำไรของเกมนี้ถึงขีดจำกัดบนของยอดการเล่นของวิธีการเล่นนี้แล้ว ไม่สามารถเล่นต่อ กรุณาเลือกวิธีการเล่นอื่น',
                    'ยอดกำไรของเกมนี้ถึงขีดจำกัดบนของยอดการเล่นของเกมนี้แล้ว กรุณาเลือกเกมอื่น',
                    'ดัชนีเปลี่นไป โปรดยืนยันก่อนแล้วค่อยเล่นใหม่',
                    'คุณได้ทายเกมในวิธีการเล่นของรูปแบบนี้แล้ว'
                ],
                'winCoin':function(num){
                    var str = 'ได้ {value} เหรียญM';
                    return str.replace(/{value}/g,'<b>' + num + '</b>');
                },
                'loginAndGet':'ล็อกอินรับรางวัล',
                'youGot':'ยินดีด้วย คุณได้รับรางวัล',
                'guideP1':'ใช้สำหรับการเล่นในเกมทายและการหมุนรางวัล รีบร่วมกิจกรรมด้วยกัน',
                'guideP2':'สะสมคูปองสามารถแลกสินค้าในร้านค้า',
                'guideP3':'เฉพาะผู้ใช้ที่ล็อกอินครั้งแรก',
                'guideP4':'วิธีการเล่นหลากลายในการลุ้นเหรียญM',
                'guideP5':'หมุนวงล้อลุ้นโชคแลกรางวัลชิ้นใหญ่',
                'signError':'คุณเซ็นชื่อในวันนี้แล้ว พรุ่งนี้ค่อยมาใหม่เถอะ',
                'signSuccess':'เซ็นชื่อสำเร็จ！',
                'firstDay':'วันที่  1',
                'secondDay':'วันที่  2',
                'thirdDay':'วันที่  3',
                'waitGet':'รอรับรางวัล',
                'done':'เสร็จสิ้น',
                'toFinish':'รับเพิ่ม',
                'todayTask':'กิจกรรมวันนี้',
                'toBet':'ไปเล่น',
                'toReward':'ไปหมุนรางวัล',
                'signIn':'กดเซ็นชื่อ',
                'taskFinishTip':'สุดยอด กิจกรรมของวันนี้เสร็จแล้ว',
                'moreGuessHistory':'ดูสถิติการทายเพิ่ม',
                'orderSn':'เลขที่บิล',
                'betPlayType':'วิธีการเล่น',
                'handicap':'ราคา',
                'betTypeAndOdds':'วิธีการเล่น&อัตราต่อรอง',
                'betNum':'ยอดเล่น',
                'betTime':'เวลาเล่น',
                'remark':'หมายเหตุ',
                'cancelOrigin':'เหตุผลในการยกเลิก',
                'returnAll':'คืนเหรียญMทั้งหมด',
                'all':'ทั้งหมด',
                'hasReward':'ออกรางวัลแล้ว',
                'rewarding':'รอออกรางวัล',
                'hasCancel':'ยกเลิกแล้ว',
                'betFail':'เล่นล้มเหลว',
                'betFailTxt':'การส่งมอบเกมทายของคุณเกิดปัญหา โปรดดำเนินการใหม่',
                'betSuccess':'เล่นสำเร็ว',
                'betting':'กำลังส่งมอบอยู่',
                'guessHistory':'บิลของเกมทาย',
                'goOnGuess':'ทายต่อ',
                'leagueScreen':'เลือกรายการ',
                'allSelect':'เลือกทั้งหมด',
                'contractSelect':'เลือกตรงกันข้าม',
                'confirm':'ตกลง',
                'know':'รับรู้แล้ว',
                'close':'ปิด',
                'cancel':'ยกเลิก',
                'totalBet':'ยอดการเล่น',
                'totalBack':'ชนะ',
                'select':'เล่นแล้ว',
                'login': 'คลิกเพื่อล็อกอิน',
                'userCenter': 'เกี่ยวกับฉัน',
                'mGuess': 'ทาย',
                'mTask': 'กิจกรรม',
                'mMall': 'ร้านค้า',
                'mGuessList': 'บิลของเกมทาย',
                'mRule': 'กฎกติกาของเกมทาย',
                'mMessage': 'การแจ้งเตือน',
                'noticeTitle': 'การแจ้งเตือนของฉัน',
                'exchangeTitle': 'บันทึกการแลกเปลี่ยน',
                'exchangeTab': ['ทั้งหมด', 'รอการตรวจสอบ', 'แลกเปลี่ยนสำเร็จ', 'แลกเปลี่ยนล้มเหลว'],
                'eShopCode': 'หมายเลขของคูปองซื้อของ：',
                'eCopy': 'ก๊อปปี้',
                'eOrder': 'เลขที่บิล：',
                'eCoupon': 'ใช้คูปองM：',
                'eM': ' คูปองM',
                'eStartTime': 'เวลาเริ่ม：',
                'eEndTime': 'เวลาเสร็จสิ้น：',
                'noData': 'ไม่พบข้อมูล',
                'eCopySuccess': 'ก๊อปปี้สำเร็จ',
                'myCoins': 'เหรียญMของฉัน',
                'myCoupon': 'คูปองMของฉัน',
                'unit': 'ใบ',
                'giftChange': 'แลกรางวัล',
                'changeRecord': 'บันทึกการแลกเปลี่ยน',
                'changeBtn': 'แลกเปลี่ยน',
                'needMore': 'ยังขาด #p ใบ',
                'changeLeft': 'เหลือ #p',
                'changeTips': 'ต้องการคูปองM #p ใบในการแลกเปลี่ยน',
                'confirmTitle': 'คำชี้แจงการดำเนินงาน',
                'confirmCancel': 'ยกเลิก',
                'confirmText': 'ตกลง',
                'confirmNow': 'รับรู้แล้ว',
                'confirmExchange': 'การแลกเปลี่ยนครั้งนี้จะใช้คูปองM #p ใบ',
                'confirmSuccessTitle': 'แลกเปลี่ยนสำเร็จ!',
                'confirmSuccessTips': 'พนักงานจะจัดการให้คุณในเร็วๆนี้!',
                'confirmErrorTitle': 'แลกเปลี่ยนล้มเหลว',
                'confirmErrorTips': 'เกิดปัญหาในการส่งมอบ กรุณาดำเนินการใหม่',
                'luckyDraw': 'หมุนรางวัล',
                'lotteryTab': ['หมุนฟรี', 'หมุนรางวัลด้วย เหรียญM'],
                'lotteryNavTab': ['กติกาการหมุนรางวัล', 'บันทึกการถูกรางวัล'],
                'lotteryPrize': 'รางวัล',
                'lotteryTime': 'เวลาถูกรางวัล',
                'lotteryMore': 'ดูเพิ่ม',
                'lotteryNoLogin': 'ล็อกอินลุ้นรางวัล',
                'lotteryFreeChangeTips': 'มีโอกาสหมุนรางวัลฟรี <strong>#p</strong> ครั้ง',
                'lotteryFreeEnd': 'โอกาสหมุนรางวัลฟรีของวันนี้ใช้หมดแล้ว',
                'lotteryChangeTips': 'ยังมีโอกาสหมุนรางวัลอีก <strong>#p</strong> ครั้ง',
                'lotteryFree': 'ฟรี',
                'lotteryClose': 'ปิด',
                'lotteryMCoinNo': 'เหรียญMของคุณไม่เพียงพอ ไม่สามารถเข้าร่วมกิจกรรมหมุนรางวัล',
                'lotteryWinTitle': 'ยินดีด้วย คุณได้รับรางวัล',
                'lotteryWinTips': 'พนักงานจะจัดการให้คุณในเร็วๆนี้ โปรดเช็คดูการบันทึกของรางวัล',
                'lotteryWinName': ['', '#p คูปองM', '#p เหรียญM', 'คูปองชื้อของหยวนของ[amazon]'],
                'lotterySorryTips': 'เสียดายจัง คุณไม่ได้รางวัล ลองใหม่อีกครั้งเถอะ',
                'lotteryConfirm': 'ตกลง',
                'lotteryCheck': 'ไปเช็คดู',
                'loginFirst': 'โปรดล็อกอินก่อน'
			},
			'vn':{
				'7mSport':'Dự đoán 7M',
                'guessOrder':'Đơn hàng dự đoán',
                'guessOrderDetail':'Chi tiết đơn hàng',
                'guessRule':'Quy tắc dự đoán',
                'mCoin':'MCoin',
                'market':'Cửa hàng',
                'reward':'Rút Thưởng',
                'task':'Nhiệm vụ',
                'taskRule':'Giới thiệu về nhiệm vụ',
                'today':'Hôm nay',
                'future':'Tương lai',
                'betUpLimit':'Đã đạt hạn mức tối đa',
                'bet':'Đặt cược',
                'hot':'Hot',
                'new':'Mới nhất',
                'locked':'Kết thúc',
                'screenError':'Phải chọn ít nhất 1 giải đấu',
                'hasBet':'Đã tham gia dự đoán với cách chơi này',
                'oneBet':'Mỗi cách chơi chỉ có thể lựa chọn 1 loại nội dung đặt cược',
                'noMatch':'Tạm không có trận đấu có thể dự đoán',
                'sealAccout':'Thao tác lần này vô hiệu vì tài khoản của bạn tồn tại hành vi không hợp lệ',
                'playType':['','1x2','Cược Chấp','Tài/Xỉu'],
                'winCoinBack':function(num){
                    return 'Hoàn trả khi thắng<span>' + num + '</span>MCoin'
                },
                'betName':'Danh sách đặt cược',
                'overBetMax':'Tối đa có thể đồng thời đặt cược {value} trận, vui lòng thêm lại sau khi hoàn thành đặt cược',
                'playOption':[
                    [],
                    ['Chủ thắng','Khách thắng','Hòa'],
                    ['Chủ thắng','Khách thắng'],
                    ['Tài','Xỉu']
                ],
                'errorTip':[
                    '',
                    'Mỗi lần phải đặt tối thiểu {value} MCoin',
                    'Mỗi lần có thể đặt tối đa {value} MCoin',
                    'Mỗi lần có thể trả lại tối đa {value} MCoin',
                    'Dự đoán đã kết thúc.',
                    'Thời gian đặt cược đã kết thúc.',
                    'Số dư Mcoin của bạn không đủ để đặt cược, số dư hiện tại là {value} MCoin',
                    'Tỷ lệ đã thay đổi',
                    'Hôm nay bạn tối đa còn có thể đặt cược {value} MCoin.',
                    'Wow! Hôm nay bạn đã đặt cược đến mức tối đa {value} MCoin rồi, hãy nghỉ ngơi một chút đi.',
                    'Bạn tối đa còn có thể đặt cược {value} MCoin vào trận này.',
                    'Không thể tiếp tục đặt cược vì đã đạt tới mức đặt cược tối đa. ',
                    'Số lượng hoàn trả đã đạt tới mức tối đa của nội dung này. Vui lòng chọn nội dung khác.',
                    'Số lượng hoàn trả đã đạt tới mức tối đa của cách chơi này. Vui lòng chọn cách chơi khác.',
                    'Số lượng hoàn trả đã đạt tới mức tối đa của trận này. Vui lòng chọn trận đấu khác.',
                    'Tỷ lệ đã thay đổi',
                    'Đã tham gia dự đoán với cách chơi này'
                ],
                'winCoin':function(num){
                    var str = 'Thắng {value} MCoin';
                    return str.replace(/{value}/g,'<b>' + num + '</b>');
                },
                'loginAndGet':'Đăng Nhập Nhận Quà',
                'youGot':'Chúc mừng bạn nhận được',
                'guideP1':'Có thể sử dụng MCoin chơi dự đoán và rút thưởng, tham gia ngay',
                'guideP2':'Tích lũy M-Coupon có thể đến cửa hàng đổi hàng ',
                'guideP3':'Chỉ dành cho người dùng đăng nhập lần đầu',
                'guideP4':'Nhiều cách chơi thắng MCoin',
                'guideP5':'Vòng quay may mắn đổi quà khủng',
                'signError':'Hôm nay đã hoàn thành nhiệm vụ Login, không cần Login lại nữa!',
                'signSuccess':'Login thành công!',
                'firstDay':'1st Day',
                'secondDay':'2nd Day',
                'thirdDay':'3rd Day',
                'waitGet':'Đang chờ nhận',
                'done':'Finished',
                'todayTask':'Nhiệm vụ hôm nay',
                'toBet':'Đi đặt cược',
                'toFinish':'Hoàn Thành Ngay',
                'toReward':'Rút Thưởng Ngay',
                'signIn':'Login',
                'taskFinishTip':'Hay quá, đã hoàn thành nhiệm vụ hôm nay.',
                'moreGuessHistory':'Lịch sử dự đoán nhiều hơn',
                'orderSn':'Số đơn hàng',
                'betPlayType':'Cách chơi',
                'handicap':'Soi kèo',
                'betTypeAndOdds':'Cách chơi đặt cược & Tỷ lệ',
                'betNum':'Số lượng đặt cược',
                'betTime':'Thời gian đặt cược',
                'remark':'Chú thích',
                'cancelOrigin':'Lý do hủy',
                'returnAll':'Trả lại toàn bộ MCoin',
                'all':'All',
                'hasReward':'Đã mở thưởng',
                'rewarding':'Chờ mở thưởng',
                'hasCancel':'Đã hủy',
                'betFail':'Đặt cược thất bại',
                'betFailTxt':'Bị lỗi khi đưa đơn dự đoán, xin vui lòng thử lại.',
                'betSuccess':'Đặt cược thành công!',
                'betting':'Đang nỗ lực ...',
                'guessHistory':'Đơn hàng dự đoán',
                'goOnGuess':'Tiếp tục dự đoán',
                'leagueScreen':'Lựa chọn giải đấu',
                'allSelect':'Chọn hết',
                'contractSelect':'Chọn ngược',
                'confirm':'Xác nhận',
                'know':'Biết rồi',
                'close':'Đóng',
                'cancel':'Hủy',
                'totalBet':'Tổng cộng đặt cược',
                'totalBack':'Dự tính trả lại',
                'select':'Đã đặt',
                'login': 'Đăng nhập',
                'userCenter': 'Trung tâm của tôi',
                'mGuess': 'Dự đoán',
                'mTask': 'Nhiệm vụ',
                'mMall': 'Cửa hàng',
                'mGuessList': 'Đơn hàng dự đoán',
                'mRule': 'Quy tắc dự đoán',
                'mMessage': 'Thông báo',
                'noticeTitle': 'Thông báo của tôi',
                'exchangeTitle': 'Lịch sử đổi quà',
                'exchangeTab': ['All', 'Chờ xét duyện', 'Đổi thành công', 'Đổi thất bại'],
                'eShopCode': 'Mã voucher：',
                'eCopy': 'Sao chép',
                'eOrder': 'Số đơn hàng：',
                'eCoupon': 'Dùng M-Coupon：',
                'eM': ' M-Coupon',
                'eStartTime': 'Thời gian bắt đầu：',
                'eEndTime': 'Thời gian hoàn thành：',
                'noData': 'Tạm thời không có nội dung',
                'eCopySuccess': 'Sao chép thành công',
                'myCoins': 'MCoin của tôi',
                'myCoupon': 'M-Coupon của tôi',
                'unit': 'Chiếc',
                'giftChange': 'Đổi quà hấp dẫn',
                'changeRecord': 'Lịch sử đổi quà',
                'changeBtn': 'Có thể đổi',
                'needMore': 'Còn thiếu #p chiếc',
                'changeLeft': 'Còn có #p',
                'changeTips': 'Có đủ #p chiếc M-Coupon mới có thể đổi được',
                'confirmTitle': 'Nhắc nhớ',
                'confirmCancel': 'Hủy',
                'confirmText': 'Xác nhận',
                'confirmNow': 'Biết rồi',
                'confirmExchange': 'Sẽ sử dụng #p M-Coupon để đổi lần này',
                'confirmSuccessTitle': 'Đổi thành công!',
                'confirmSuccessTips': 'Nhân viên liên quan sẽ giải quyết cho bạn sớm nhất có thể!',
                'confirmErrorTitle': 'Đổi thất bại',
                'confirmErrorTips': 'Đã xảy ra lỗi, vui lòng thử lại.',
                'luckyDraw': 'Rút Thưởng',
                'lotteryTab': ['Rút miễn phí', 'MCoin rút'],
                'lotteryNavTab': ['Quy Tắc Rút Thưởng', 'Lịch Sử Trúng Thưởng'],
                'lotteryPrize': 'Giải thưởng',
                'lotteryTime': 'Thời gian nhận thưởng',
                'lotteryMore': 'Load More',
                'lotteryNoLogin': 'Đăng nhập để rút thưởng khủng',
                'lotteryFreeChangeTips': 'Có <strong>#p</strong> lần cơ hội rút thưởng miễn phí',
                'lotteryFreeEnd': 'Cơ hội rút thưởng miễn phí hôm nay đã hết',
                'lotteryChangeTips': 'Còn có <strong>#p</strong> lần cơ hội rút thưởng',
                'lotteryFree': 'Miễn phí',
                'lotteryClose': 'Đóng',
                'lotteryMCoinNo': 'Bạn không có đủ MCoin, không thể tham gia rút thưởng',
                'lotteryWinTitle': 'Chúc mừng bạn nhận được',
                'lotteryWinTips': 'Nhân viên liên quan sẽ giải quyết cho bạn sớm nhất có thể, xin hãy chú ý xem lịch sử trúng thưởng',
                'lotteryWinName': ['', '#p M-Coupon', '#p MCoin', 'Amazon voucher '],
                'lotterySorryTips': 'Rất đáng tiếc, bạn chưa trúng thưởng, hãy thử lại một lần nữa!',
                'lotteryConfirm': 'Xác nhận',
                'lotteryCheck': 'Đi xem ngay',
                'loginFirst': 'Vui lòng đăng nhập trước'
			}
		}
	}
}


// WEBPACK FOOTER //
// ./src/lib/lang.js